import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { StyledTextField, StyledDatePicker, theme } from "../StyledComponents";
import { appointmentData } from "../Utils/SectionsDataMap";
import FollowUp from "./FollowUp";
import Referral from "./Referral";
import { Card, Typography } from "@mui/material";

export default function FollowUpReferralComp({
  sectionName,
  activeSection,
  followUpData,
  referralData,
  setFollowUpData,
  setReferralData,
  setFollowUpError,
  setReferralError,
  followUpError,
  referralError,
  dateForAppointment
}) {
  useEffect(() => {
    if (followUpData.length > 0) {
      setFollowUpDetails(followUpData[0]);
    } else {
      setFollowUpDetails({
        start_date: null,
        service_type: "",
        duration: "",
        durationType: "",
      });
    }
  }, [followUpData]);

  useEffect(() => {
    if (referralData.length > 0) {
      setReferralDetails(referralData[0]);
    } else {
      setReferralDetails({
        service_category: null,
        service_description: "",
        doctor_details: null,
      });
    }
  }, [referralData]);

  const [followUpDetails, setFollowUpDetails] = useState(
    followUpData.length > 0
      ? followUpData[0]
      : {
        start_date: null,
        service_type: "",
        duration: "",
        durationType: "",
      }
  );

  const [referralDetails, setReferralDetails] = useState(
    referralData.length > 0
      ? referralData[0]
      : {
        service_category: null,
        service_description: "",
        doctor_details: null,
      }
  );
  // console.log("followupData", followUpData);
  // console.log("followupDetails", followUpDetails);
  // console.log("referralDetails", referralDetails);
  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <div>
          <FollowUp
            sectionName={sectionName}
            activeSection={activeSection}
            data={followUpData}
            setData={setFollowUpData}
            setFollowUpError={setFollowUpError}
            followUpError={followUpError}
            details={followUpDetails}
            setDetails={setFollowUpDetails}
            dateForAppointment={dateForAppointment}
          />

          <Referral
            sectionName={sectionName}
            activeSection={activeSection}
            data={referralData}
            setData={setReferralData}
            setAppointmentError={setReferralError}
            appointmentError={referralError}
            details={referralDetails}
            setDetails={setReferralDetails}
          />
        </div>
      ) : (
        appointmentData(
          [{ ...followUpDetails }],
          [{ ...referralDetails }],
          followUpError,
          referralError
        )
        // []
      )}
    </ThemeProvider>
  );
}
